// extracted by mini-css-extract-plugin
export default {"PhotoCropInput":"bfs_a"};